export function calcularLabelFormatterComValoresMaximosMinimosEMedios(series, pontos) {
  const valoresAgrupadosPorPesquisa = [];

  const valoresMaximos = [];
  const valoresMinimos = [];
  const valoresMedios = [];

  for (let posicaoPesquisa = 0; posicaoPesquisa < pontos.length; posicaoPesquisa ++) {
    if (!Array.isArray(valoresAgrupadosPorPesquisa[posicaoPesquisa])) {
      valoresAgrupadosPorPesquisa[posicaoPesquisa] = [];
    }

    const dataValuePorPosicaoPesquisa = series
      .map(serie => serie.data[posicaoPesquisa] ? serie.data[posicaoPesquisa].value : null)
      .filter(valor => typeof valor === "number");

    valoresAgrupadosPorPesquisa[posicaoPesquisa].push(
      ...dataValuePorPosicaoPesquisa
    );
  }
  
  for (let posicaoAgrupamento = 0; posicaoAgrupamento < valoresAgrupadosPorPesquisa.length; posicaoAgrupamento ++) {
    const valoresAgrupados = valoresAgrupadosPorPesquisa[posicaoAgrupamento]
      .filter(v => typeof v === "number");

    const possuiComprimento = valoresAgrupados.length > 0;

    if (possuiComprimento) {
      valoresMaximos.push(Math.max(...valoresAgrupados));
      valoresMinimos.push(Math.min(...valoresAgrupados));

      const valoresAgrupadosSemRepeticao = [];

      valoresAgrupados.forEach(v => {
        if (!valoresAgrupadosSemRepeticao.includes(v)) {
          valoresAgrupadosSemRepeticao.push(v);
        }
      });

      valoresMedios.push([...valoresAgrupadosSemRepeticao].sort((a, b) => a - b)[Math.floor(valoresAgrupadosSemRepeticao.length / 2)]);
    }
  }

  return series.map(serieOriginal => ({
      ...serieOriginal,
      label: {
        ...serieOriginal.label,
        formatter: (params) => {
          const agrupamentoIndex = params.dataIndex;
          const valorAtual = params.data.value;

          if (valoresMaximos[agrupamentoIndex] == valorAtual 
              || valoresMinimos[agrupamentoIndex] == valorAtual
              || valoresMedios[agrupamentoIndex] == valorAtual
          ) {
            return `${params.data.value}%`;
          }

          return "";
        },
      }
    }))
}